import { SCREEN_FILTER_CODE } from "constants/DashboardContanst";
import {
  AUTH_STATUS_APPROVE,
  AUTH_STATUS_AR,
  AUTH_STATUS_CANCEL,
  AUTH_STATUS_CANCEL_WAITING,
  AUTH_STATUS_NEW,
  AUTH_STATUS_PROGRESSING,
  AUTH_STATUS_REJECT,
  AUTH_STATUS_REJECT_CANCEL,
  AUTH_STATUS_RR,
} from "constants/FormatDataContanst";
import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import ListInvoice from "./ListInvoice";

const ListAllInvoice = () => {
  const [filterList, setFilterList] = useState({
    // "filter[auth_status][in]": [
    //   AUTH_STATUS_NEW,
    //   AUTH_STATUS_APPROVE,
    //   AUTH_STATUS_PROGRESSING,
    //   AUTH_STATUS_REJECT,
    //   AUTH_STATUS_CANCEL_WAITING,
    //   AUTH_STATUS_REJECT_CANCEL,
    //   AUTH_STATUS_CANCEL,
    //   AUTH_STATUS_AR,
    //   AUTH_STATUS_RR,
    // ],
  });

  const Dashboard = useSelector(state => state.Dashboard);
  const { finalBuInfo } = Dashboard;

  // Action list chang tenantCode
  useEffect(() => {
    if (finalBuInfo) {
      setFilterList({
        "filter[invoice_type]": finalBuInfo?.invoice_type,
      });
    }
  }, [finalBuInfo]);

  return (
    <React.Fragment>
      <ListInvoice
        filterList={filterList}
        screenFilterCode={SCREEN_FILTER_CODE.INVOICE_ALL}
        listStatusFilter={[
          AUTH_STATUS_NEW,
          AUTH_STATUS_APPROVE,
          AUTH_STATUS_PROGRESSING,
          AUTH_STATUS_REJECT,
          AUTH_STATUS_CANCEL_WAITING,
          AUTH_STATUS_REJECT_CANCEL,
          AUTH_STATUS_CANCEL,
          AUTH_STATUS_AR,
          AUTH_STATUS_RR,
        ]}
        title={"DANH SÁCH TẤT CẢ HÓA ĐƠN"}
        titleManger={"HÓA ĐƠN"}
      />
    </React.Fragment>
  );
};

export default ListAllInvoice;
